// removed by extract-text-webpack-plugin
module.exports = {"item":"_2o3-RUQxFqvyME6YR3dll_","popoverContainer":"OjK9kMKxZKwpryuACI4br","name":"_11r4tpnNdcgdOehWSJU066","lockedIcon":"_18-9_VK_q9rI-ypR2gF6Yn","shown":"_2HPpsBbgxF967bNXoQZx9U","popoverContent":"aPF5U5o3SBeaJbI_fbORy","popoverItem":"_3kJcZz-oPaz0oNnBUutlqW","selected":"_3qHQ55JpahO3_tY79EjPln"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Sections/Roles/style/RoleItem.pcss
// module id = 1158
// module chunks = 0